<template>
  <div class="grid grid-cols-5 gap-3 p-3 rounded-2xl">
    <div v-for="(square, index) in squares" :key="index" class="aspect-square">
      <div 
        :class="[
          'bingo-square', 
          square.isChecked ? 'checked' : ''
        ]"
        @click="$emit('update-square', index)"
      >
        <div class="text-xs sm:text-sm md:text-base font-medium p-1 line-clamp-4">
          {{ square.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BingoCard',
  props: {
    squares: {
      type: Array,
      required: true
    }
  },
  emits: ['update-square']
}
</script>